import isEmpty from "lodash/isEmpty";
import size from "lodash/size";
import trim from "lodash/trim";

import AuthStore from "./AuthStore";
import ChatActions from "../../actions/ChatActions";
import alt from "../../alt/ChatAlt";
import ConfigStore from "./ConfigStore";
import { validateEmail, validatePhone } from "../../utils/Utils";

export class AskFormStore {
    constructor() {
        this.bindActions(ChatActions);
        this.bindListeners({
            onProcessing: [ChatActions.askQuestion, ChatActions.updateContact],
            onProcessingFail: [ChatActions.askQuestionFail, ChatActions.updateContactFail],
        });

        this.state = {
            contactInfo: "",
            error: null,
            isProcessing: false,
            hasContactInfo: false,
            lastResponseTimeInMillis: null,
            questionText: "",
            userName: "",
        };
    }

    onProcessing() {
        this.setState({ error: null, isProcessing: true });
    }

    onProcessingFail({ error }) {
        this.setState({ error, isProcessing: false });
    }

    onAskQuestionSuccess({ contactInfo = "" } = {}) {
        this.setState({
            contactInfo,
            error: null,
            hasContactInfo: !isEmpty(contactInfo) || this.state.hasContactInfo,
            isProcessing: false,
            questionText: "",
        });
    }

    onUpdateContactSuccess({ contactInfo }) {
        this.setState({ contactInfo, error: null, hasContactInfo: true, isProcessing: false });
    }

    onAuthSuccess({ hasContactInfo }) {
        this.setState({ hasContactInfo });
    }

    onLoadLastResponseTimeSuccess({ lastResponseTimeInMillis }) {
        this.setState({ lastResponseTimeInMillis });
    }

    onLogoutSuccess() {
        this.setState({ contactInfo: "", hasContactInfo: false, questionText: "", userName: "" });
    }

    onResetAuth() {
        this.waitFor(ConfigStore);
        const { userEmail, userName, userPhone } = ConfigStore.getConfig();

        this.setState({
            contactInfo: userEmail || userPhone || "",
            hasContactInfo: !validateEmail(userEmail) || !validateEmail(userPhone),
            userName: userName || "",
        });
    }

    onUpdateUserName(userName) {
        this.setState({ userName });
    }

    onUpdateQuestion(questionText) {
        this.setState({ questionText });
    }

    onUpdateContactInfo(contactInfo) {
        this.setState({ contactInfo });
    }

    static shouldDisplayUserName() {
        const { isLoggedIn } = AuthStore.getState();
        const { userName } = ConfigStore.getConfig();

        return !isLoggedIn && size(trim(userName)) === 0;
    }

    static shouldDisplayContactInfo() {
        const { userEmail, userPhone } = ConfigStore.getConfig();
        const { hasContactInfo } = this.getState();
        const prefilledContactInfoIsValid = validateEmail(userEmail) || validatePhone(userPhone);

        return hasContactInfo ? false : !prefilledContactInfoIsValid;
    }

    static contactInfoWasPrefilled() {
        const { userEmail, userPhone } = ConfigStore.getConfig();

        return validateEmail(userEmail) || validateEmail(userPhone) || false;
    }

    static isUserNameValid() {
        const { isLoggedIn } = AuthStore.getState();
        const { userName } = this.getState();

        return isLoggedIn || size(trim(userName)) > 0;
    }

    static isQuestionTextValid() {
        return size(trim(this.getState().questionText)) > 0;
    }

    static isContactInfoValid() {
        const { contactInfo, hasContactInfo } = this.getState();
        const { allowQuestionSignupWithPhoneNumber } = window.companySettings;
        const contactInfoIsValidEmail = size(trim(contactInfo)) > 0 && validateEmail(contactInfo);
        const contactInfoIsValidPhone =
            allowQuestionSignupWithPhoneNumber && size(trim(contactInfo)) > 0 && validatePhone(contactInfo);

        return contactInfoIsValidEmail || contactInfoIsValidPhone || hasContactInfo;
    }
}

export default alt.createStore(AskFormStore, "AskFormStore");
